<template>
  <div>
    <div style="font-size: 18px; color: #000000; font-weight: 600; margin-bottom: 8px;">1. 選擇寵物 <span style="font-size: 14px; color: #888888;">(可上下捲動)</span></div>
    <div class="pet-radio-wrapper">
      <el-radio-group v-model="petId" class="pet-radio-group">
        <el-radio v-for="pet in currentPetOptions" :key="pet.id" :label="pet.id" border class="pet-radio-item">
          {{ pet.name || `#${pet.id}` }}
        </el-radio>
      </el-radio-group>
    </div>

    <div style="font-size: 18px; color: #000000; font-weight: 600; margin: 16px 0 8px;">2. 加購清單 <span style="font-size: 14px; color: #888888;">(可上下捲動)</span></div>
    <el-table v-loading="addonLoading" :data="addonGoods" height="420" highlight-current-row @current-change="onCurrentAddonChange">
      <el-table-column label="品項" prop="name" min-width="180"> </el-table-column>
      <el-table-column label="計價" min-width="60">
        <template slot-scope="scope">
          {{ scope.row.billingType === 'per_night' ? '每日' : scope.row.billingType === 'once' ? '單次' : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="售價">
        <template slot-scope="scope">
          {{ getAddonPriceValue(scope.row, 'price') }}
        </template>
      </el-table-column>
      <el-table-column label="原價">
        <template slot-scope="scope">
          {{ getAddonPriceValue(scope.row, 'origin') }}
        </template>
      </el-table-column>
      <el-table-column label="成本">
        <template slot-scope="scope">
          {{ getAddonPriceValue(scope.row, 'cost') }}
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: flex-end; margin-top: 8px;">
      <el-pagination
        layout="prev, pager, next"
        :current-page="addonPagination.page"
        :page-size="addonPagination.perPage"
        :total="addonPagination.total"
        @current-change="$emit('addon-page-change', $event)"
      />
    </div>

    <div style="display: flex; align-items: center; gap: 8px;">
      <div style="font-size: 18px; font-weight: 600; color: #000000;  margin-right: 12px;">3. 加購數量</div>
      <el-input-number v-model="qty" :min="1" :max="100" :step="1" />
    </div>

    <div style="margin-top: 8px; font-size: 13px; line-height: 1.5; color: #888888;">
      <div>單次計價：左側小計 = 售價</div>
      <div>每晚計價：左側小計 = 售價 × 晚數</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculatorOrderAddonPane',
  props: {
    addonLoading: {
      type: Boolean,
      default: false,
    },
    addonGoods: {
      type: Array,
      default: () => [],
    },
    addonPagination: {
      type: Object,
      default: () => ({
        page: 1,
        perPage: 15,
        total: 0,
      }),
    },
    selectedPetId: {
      type: [Number, String],
      default: null,
    },
    currentPetOptions: {
      type: Array,
      default: () => [],
    },
    addonQty: {
      type: Number,
      default: 1,
    },
    getAddonPriceValue: {
      type: Function,
      default: () => () => '-',
    },
  },
  computed: {
    petId: {
      get() {
        return this.selectedPetId
      },
      set(val) {
        this.$emit('update:selectedPetId', val)
      },
    },
    qty: {
      get() {
        return this.addonQty
      },
      set(val) {
        this.$emit('update:addonQty', val)
      },
    },
  },
  methods: {
    onCurrentAddonChange(row) {
      this.$emit('update:selectedAddonRow', row?.raw || row || null)
    },
  },
}
</script>

<style scoped>
.pet-radio-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  min-height: 180px;
  max-height: 180px;
  overflow-y: auto;
}

.pet-radio-item {
  margin-right: 0;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
}

.pet-radio-item.el-radio.is-bordered {
  display: flex;
  align-items: center;
  width: 100%;
  height: 54px;
  padding: 0px 12px;

  &.is-checked {
    border: solid 2px #ea6a2a;
  }
}

.pet-radio-item.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}

.pet-radio-item :deep(.el-radio__label) {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
